'use client'

import Link from 'next/link'

export default function Footer() {
  return (
    <footer className="bg-gray-900 text-white">
      <div className="max-w-1xl mx-auto px-4 sm:px-6 lg:px-8 pt-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          <div className='flex justify-center items-center'>
            <img
              src="https://res.cloudinary.com/dwzcgxinv/image/upload/v1758528707/Eshhar%20Real%20Estate/images/Brand%20logo/Eshar_Real_Estate_Logo_White_o7f16a.png"
              alt="Eshhar Real Estate Logo"
              className="h-25 sm:h-30 md:h-28 lg:h-36 xl:h-40 w-auto mb-4 bg-transparent max-w-full"
            />
          </div>

          <div>
            <h4 className="text-lg font-semibold mb-4">Quick Links</h4>
            <ul className="space-y-2">
              <li>
                <Link href="/signin" className="text-gray-400 hover:text-white transition-colors">
                  Sign in
                </Link>
              </li>
              <li>
                <Link href="/about" className="text-gray-400 hover:text-white transition-colors">
                  About Us
                </Link>
              </li>
              <li>
                <Link href="/contact" className="text-gray-400 hover:text-white transition-colors">
                  Contact
                </Link>
              </li>
              <li>
                <Link href="/support" className="text-gray-400 hover:text-white transition-colors">
                  Support
                </Link>
              </li>
              <li>
                <Link href="/account" className="text-gray-400 hover:text-white transition-colors">
                  Account
                </Link>
              </li>
              <li>
                <Link href="/dashboard" className="text-gray-400 hover:text-white transition-colors">
                  Dashboard
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-lg font-semibold mb-4">Contact Us</h4>
            <ul className="space-y-2 text-gray-400">
              <li>
                <a href="mailto:info@eshharholdings.com" className="hover:text-white transition-colors">
                  info@eshharrealestate.com
                </a>
              </li>
              <li>
                <a href="tel:+974 44111144" className="hover:text-white transition-colors">
                  +974 4411 1144
                </a>
              </li>
              <li>
                <a href="tel:+974 51514777" className="hover:text-white transition-colors">
                  +974 5151 4777
                </a>
              </li>
              <li>
                <a href="https://maps.app.goo.gl/WV2TotJXyoA5tPhz7" className="hover:text-white transition-colors">
                  <p>Buzwair Building, 7th Floor, Building No 57, Al Muntazah, Doha</p>
                </a>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-lg font-semibold mb-4">Legal</h4>
            <ul className="space-y-2">
              <li>
                <p className="text-gray-400">Part of <Link href="https://eshharholding.com/" className="text-gray-400 underline italic hover:text-white transition-colors">
                  Eshhar Holding
                </Link></p>
              </li>
              <li>
                <Link href="/privacy" className="text-gray-400 hover:text-white transition-colors">
                  Privacy Policy
                </Link>
              </li>
              <li>
                <Link href="/terms" className="text-gray-400 hover:text-white transition-colors">
                  Terms of Service
                </Link>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-gray-800 mt-6 pt text-center text-gray-400">
          <p>&copy; {new Date().getFullYear()} Eshhar Real Estate. All rights reserved.</p>
        </div>
      </div>
    </footer>
  )
} 